import { useState } from 'react'

import { PAGE_SIZE, pageOfLines } from '../AccountsTable/accountLines'
import { TablePager } from '../AccountsTable/TablePager'
import type { HoldingRow } from '../types'
import { type HoldingsColumns, HoldingsTable } from './HoldingsTable'
import { largestFirst } from './holdingsOrder'

// One account's holdings, largest first, a page at a time once they pass one page.
export const PagedHoldingsTable = ({
  holdings,
  columns,
}: {
  holdings: HoldingRow[]
  columns: HoldingsColumns
}) => {
  const [pageIndex, setPageIndex] = useState(0)
  const ordered = largestFirst(holdings)
  const page =
    ordered.length > PAGE_SIZE ? pageOfLines(ordered, pageIndex) : null
  return (
    <>
      <HoldingsTable holdings={page?.lines ?? ordered} columns={columns} />
      {page && <TablePager page={page} onPageChange={setPageIndex} />}
    </>
  )
}
